import { useInView } from 'react-intersection-observer';
import { useSetAtom } from 'jotai';

import {
  isPromotionBannerInViewAtom,
  useCatalogProductIdParams,
  usePdpBaseInfo,
  usePdpConfig,
} from '@domains/pdp-common';

import { usePromotionUBL } from '../log/usePromotionUBL';

export const useProductMetadata = () => {
  const { isZigzagApp } = usePdpConfig();
  const log = usePromotionUBL();
  const params = useCatalogProductIdParams();
  const setIsPromotionBannerInView = useSetAtom(isPromotionBannerInViewAtom);
  const {
    product: {
      browsing_type,
      badge: { below_atf_price_badge_list },
      product_price: { display_final_price, max_price_info },
      promotion_info,
    },
  } = usePdpBaseInfo(params);

  const floatBannerInfo = promotion_info?.float_banner_info;
  const shouldShowPromotionLayout = Boolean(floatBannerInfo);
  const hasDiscountRate = display_final_price.discount_rate > 0;
  const hasAdditionalFinalPrice = display_final_price.final_price_additional.price > 0;
  const hasBadge = below_atf_price_badge_list?.length > 0;
  const displayPriceLine = getDisplayPriceLine();

  const impressionPromotionBannerRef = useInView({
    onChange: (inView) => {
      if (!inView) {
        return;
      }
      const finalPrice = display_final_price?.final_price.price ?? 0;
      const finalPriceAdditional = display_final_price?.final_price_additional?.price ?? 0;
      log.impressionPromotionBannerUBL(
        (finalPriceAdditional ?? finalPrice).toString(),
        params.catalog_product_id,
        browsing_type,
        {
          'catalog_product_id': params.catalog_product_id,
          'price_diff': floatBannerInfo?.price_diff ?? 0,
          '1st_price': max_price_info?.price ?? 0,
          '2nd_price': finalPrice,
          '3rd_price': finalPriceAdditional,
        },
      );
    },
    triggerOnce: true,
  });

  // 프로모션 배너 visibility 추적 (플로팅 배너 표시 여부 결정용)
  const promotionBannerVisibilityRef = useInView({
    onChange: (inView) => {
      setIsPromotionBannerInView(inView);
    },
    threshold: 0,
  });

  function getDisplayPriceLine() {
    if (hasAdditionalFinalPrice) {
      return 3;
    }

    if (!hasAdditionalFinalPrice && hasDiscountRate) {
      return 2;
    }

    if (!hasDiscountRate) {
      return 1;
    }

    return 1;
  }

  const handleHeaderClick = () => {
    if (floatBannerInfo?.landing_url) {
      log.clickPromotionBannerUBL(params.catalog_product_id, browsing_type);

      if (isZigzagApp) {
        window.location.href = floatBannerInfo.landing_url;
      } else {
        window.open(
          decodeURIComponent(floatBannerInfo.landing_url.substring(floatBannerInfo.landing_url.indexOf('=') + 1)),
        );
      }
    }
  };

  return {
    floatBannerInfo,
    below_atf_price_badge_list,
    displayPriceLine,

    hasBadge,
    shouldShowPromotionLayout,

    impressionPromotionBannerRef: impressionPromotionBannerRef.ref,
    promotionBannerVisibilityRef: promotionBannerVisibilityRef.ref,
    handleHeaderClick,
  };
};
